"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var FormInputLabel = function (_a) {
    var label = _a.label, fieldName = _a.fieldName, order = _a.order, headerLabel = _a.headerLabel, conditionalLabel = _a.conditionalLabel, propertyType = _a.propertyType;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement("label", { htmlFor: fieldName, className: styles_module_scss_1.default.field_label }, !conditionalLabel
        ? t("fields.section" + order + "." + (headerLabel ? headerLabel : label))
        : t("fields.section" + order + "." + propertyType + "_quantity")));
};
exports.default = react_1.memo(FormInputLabel);
